export const HISTORY_AUTOLOAD_TOP_THRESHOLD_PX = 80;

type ShouldAutoloadHistoryOptions = {
  historyPending: boolean;
  currentHistoryLoading: boolean;
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
};

export function shouldAutoloadHistory(options: ShouldAutoloadHistoryOptions): boolean {
  if (!options.historyPending || options.currentHistoryLoading) return false;
  if (!Number.isFinite(options.scrollHeight) || !Number.isFinite(options.clientHeight)) return false;
  const isScrollable = options.scrollHeight > (options.clientHeight + 1);
  if (!isScrollable) return true;
  return options.scrollTop <= HISTORY_AUTOLOAD_TOP_THRESHOLD_PX;
}
